import request from '@/utils/request';
import { endpoints, vocabularyEndpoint } from '@/constants/urls';

const vocabularies = (filter, page, pageSize) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  return (
    request({
      url: endpoints.VOCABULARIES,
      params,
      method: 'GET',
    })
  );
};

const vocabulary = (code) => request({
  url: vocabularyEndpoint(code),
  method: 'GET',
});

const update = ({
  code,
  value,
}) => request({
  url: vocabularyEndpoint(code),
  data: {
    value,
  },
  method: 'PUT',
});

const VocabularyService = {
  vocabularies,
  vocabulary,
  update,
};

export default VocabularyService;
